export const STATE_KEY = 'siteAttributeGroups';

export const SITE_ATTRIBUTE_GROUPS_FETCH_KEY = `${STATE_KEY}.fetchSiteAttributeGroups`;

export const EMPTY_GROUPS = [];
